var styles = {"square":"VipLevelLine_square_b4mnn_1","box":"VipLevelLine_box_b4mnn_16","box-inner":"VipLevelLine_box-inner_b4mnn_19","progress":"VipLevelLine_progress_b4mnn_26","sublevel":"VipLevelLine_sublevel_b4mnn_31","squares":"VipLevelLine_squares_b4mnn_39","mobile-styles":"VipLevelLine_mobile-styles_b4mnn_55"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
